var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-widget"},[_c('img',{staticClass:"embedded-image",style:(_vm.imageDimensions),attrs:{"src":_vm.imagePath}})])
}
var staticRenderFns = []

export { render, staticRenderFns }